import { Navigate } from "react-router-dom";
import { getAdminToken } from "../../api/serviceDeskApi";
import AdminLayout from "../../components/admin/AdminLayout";

export default function AdminRequireAuth() {
  if (!getAdminToken()) {
    return <Navigate to="/admin/login" replace />;
  }
  return <AdminLayout />;
}
